function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2183.2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8067 15477l9651 -9652m-9651 9652l-4826 -4826"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20958 20958",
    style: {
      "height": "1em",
      "width": "1em"
    },
    className: "icon"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/check.94c60b40.svg";
export { SvgComponent as ReactComponent };